// Shared decoders for characteristic reads. Firmware pads fixed-width
// string characteristics with trailing NULs; the harness trims those and
// surrounding whitespace so a read-back value compares cleanly against what
// was written. Used for the Device Information revision strings and for the
// WiFi credential read-back (§311 / §312).
export function decodeUtf8(view) {
    return new TextDecoder('utf-8').decode(view).replace(/\0+$/, '').trim();
}
/**
 * Little-endian unsigned integer decode for WiFi Error (§315).
 *
 * Width-tolerant on purpose, in the same spirit as the §216 decoder: assemble
 * from whatever bytes actually arrived rather than demanding a documented
 * width. D-005 cost the entire WiFi status pipeline because the harness
 * decoded §216 as the documented uint16 while firmware sent one byte, and
 * every notification threw. §315 is the same trap set differently — the only
 * written description of it anywhere is a commented-out line in the firmware
 * header (`ble_soluu.h:63`) that claims `R uint8`, while the code registers
 * READ|NOTIFY over a `uint32_t`. See D-009.
 *
 * Returns an unsigned value: `>>> 0` keeps 0xFFFFFFFF from surfacing as -1.
 * Throws only on an empty payload, which carries no value at all.
 */
export function decodeUint32LE(view) {
    if (view.byteLength === 0) {
        throw new RangeError('Cannot decode a uint32 from an empty payload');
    }
    let value = 0;
    const width = Math.min(view.byteLength, 4);
    for (let i = width - 1; i >= 0; i -= 1) {
        value = value * 256 + view.getUint8(i);
    }
    return value >>> 0;
}
//# sourceMappingURL=decode.js.map